// extracted by mini-css-extract-plugin
module.exports = {"root":"design-prototype_root__Z5Mo1","title":"design-prototype_title__1ug0_","text":"design-prototype_text__SPsq0","banner":"design-prototype_banner__qlqNN"};